import React from "react";
import { X } from "lucide-react";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

const TestSeriesPopup = ({ showPopup, onClose, title }) => {
  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative animate-fadeIn text-center">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
        >
          <X size={20} />
        </button>

        <h2 className="text-2xl font-bold text-center text-gray-800 mb-1">
          Enquire Now
        </h2>
        <p className="text-center text-sm text-gray-500 mb-5">
          {title || "Selected Test Series"}
        </p>
        <p className="text-gray-600 mb-6">
          To enroll or know more about this test series, please contact us directly using any of the methods below.
        </p>

        <div className="space-y-4 mb-2">
          <a
            href="tel:+918012003040"
            className="flex items-center justify-center gap-2 bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition"
          >
            <MdPhone className="text-blue-600 text-xl" /> +91 8012003040
          </a>
          <a
            href="tel:+917449203040"
            className="flex items-center justify-center gap-2 bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition"
          >
            <MdPhone className="text-blue-600 text-xl" /> +91 7449203040
          </a>
          <a
            href="mailto:selvasiasacademy@gmail.com"
            className="flex items-center justify-center gap-2 bg-gray-100 p-3 rounded-lg hover:bg-gray-200 transition"
          >
            <MdEmail className="text-blue-600 text-xl" /> selvasiasacademy@gmail.com
          </a>
          <a
            href="https://wa.me/918012003040"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-green-500 text-white p-3 rounded-lg hover:bg-green-600 transition"
          >
            <FaWhatsapp className="text-xl" /> Chat on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default TestSeriesPopup;
